import { Box, Heading, HStack, Label } from '@medely/ui-kit';
import { HideFrom } from '@mp/components/HideFrom';
import { centsToCurrency, DisplayHelpers } from '@mp/utils';
import React from 'react';
import { MissingInfoCard } from './components/MissingInfoCard';
import { useMissingAssignmentChecklistInfoForAssignmentDetails } from './graphql';
import { FragmentType, parseFragmentData } from '@mp/graphql/generated';
import { AssignmentForAssignmentDetailsGql } from '../graphql';

type AssignmentDetailsHeaderProps = {
  assignment?: FragmentType<typeof AssignmentForAssignmentDetailsGql> | null;
};

export const AssignmentDetailsHeader = ({
  assignment: inputAssignment,
}: AssignmentDetailsHeaderProps) => {
  const assignment = parseFragmentData(AssignmentForAssignmentDetailsGql, inputAssignment);

  const { isAssignmentApplicationMissingInformation } =
    useMissingAssignmentChecklistInfoForAssignmentDetails(assignment?.id);

  const showMissingInfoCard =
    isAssignmentApplicationMissingInformation && assignment?.vms_partnership;

  return (
    <>
      {showMissingInfoCard && (
        <Box py={2}>
          <MissingInfoCard assignmentId={assignment?.id} />
        </Box>
      )}

      <Box mb={2}>
        <Heading size="s" testId="assignment-details-position">
          {DisplayHelpers.assignment.positions(assignment?.positions)}
        </Heading>
      </Box>
      <HStack gap={1}>
        <HideFrom agency>
          <Label size="l" color="state.success.secondary" testId="assignment-details-pay-per-week">
            {centsToCurrency(assignment?.pay_per_week_cents || 0)}/wk
          </Label>
        </HideFrom>
        {Boolean(assignment?.one_time_bonus_burden_cents) && (
          <Label size="l" color="state.success.secondary" testId="assignment-details-boost">
            + {centsToCurrency(assignment?.one_time_bonus_burden_cents ?? 0)} bonus
          </Label>
        )}
      </HStack>
    </>
  );
};
